module.exports = __webpack_public_path__ + "static/laboheme1s-0a360575de142873b26a4720d7ecf37e.jpg";